<template>
  <div class="products">
    <div class="content-wrapper">
      <div class="title-box">
        <span>评价管理</span>
        <div class="search-box">
          <input v-model="form_data.keyword" type="text" placeholder="输入订单编号或商品名称搜索" @keyup.enter="onSearch" />
          <img class="search-icon-btn" src="@/assets/images/icon-search.png" alt="" />
        </div>
      </div>
      <div class="info-card-box">
        <div class="info-card">
          <div class="top">
            <span class="">总评论数</span>
          </div>
          <div class="bottom">
            <span class="value">{{ statisticsCount.total_count }}条</span>
            <span class="change-num">+{{ statisticsCount.total_count_pct }}%</span>
            <span class="change-desc">较上个月</span>
          </div>
        </div>
        <div class="info-card">
          <div class="top">
            <span class="">好评率</span>
          </div>
          <div class="bottom">
            <span class="value">{{ statisticsCount.good_rate }}%</span>
            <span class="change-num">+{{ statisticsCount.good_rate_pct }}%</span>
            <span class="change-desc">较上个月</span>
          </div>
        </div>
        <div class="info-card">
          <div class="top">
            <span class="">待回复评价</span>
          </div>
          <div class="bottom">
            <span class="value warn">{{ statisticsCount.seller_wait_count_week }}条</span>
            <span class="change-num warn">+{{ statisticsCount.seller_wait_count_week_diff }}条</span>
            <span class="change-desc warn">较上周</span>
          </div>
        </div>
        <div class="info-card">
          <div class="top">
            <span class="">中差评数</span>
          </div>
          <div class="bottom">
            <span class="value warn">{{ statisticsCount.bad_mid_count_week }}条</span>
            <span class="change-num warn">+{{ statisticsCount.bad_mid_count_week_diff }}条</span>
            <span class="change-desc warn">较上周</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="tool-bar-box">
        <div class="title">全部订单评价({{ statisticsCount.total_count }})</div>
        <div class="divider-row"></div>
        <div class="filter-box">
          <div class="left">
            <div class="filter-item-box">
              <span>评价等级：</span>
              <div class="filter-item-value-box">
                <div class="filter-item" :class="{'active': form_data.rating_tag === 'all'}" @click="handleFilter('rating_tag','all')">
                  <span>全部</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.rating_tag === 'good'}" @click="handleFilter('rating_tag','good')">
                  <span>好评</span>
                  <span>{{ statisticsCount.good_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.rating_tag === 'middle'}" @click="handleFilter('rating_tag','middle')">
                  <span>中评</span>
                  <span class="warn">{{ statisticsCount.mid_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.rating_tag === 'poor'}" @click="handleFilter('rating_tag','poor')">
                  <span>差评</span>
                  <span class="warn">{{ statisticsCount.bad_count }}</span>
                </div>
              </div>
            </div>
            <div class="filter-item-box">
              <span>评价内容：</span>
              <div class="filter-item-value-box">
                <div class="filter-item" :class="{'active': form_data.comment_type === 'has_image'}" @click="handleFilter('comment_type','has_image')">
                  <span>有图片</span>
                  <span>{{ statisticsCount.has_image_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.comment_type === 'has_video'}" @click="handleFilter('comment_type','has_video')">
                  <span>有视频</span>
                  <span>{{ statisticsCount.has_video_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.comment_type === 'reply'}" @click="handleFilter('comment_type','reply')">
                  <span>互动回复</span>
                  <span>{{ statisticsCount.reply_count }}</span>
                </div>
              </div>
            </div>
            <div class="filter-item-box">
              <span>状态：</span>
              <div class="filter-item-value-box">
                <div class="filter-item" :class="{'active': form_data.sellerReplyStatus === 'waitreply'}" @click="handleFilter('sellerReplyStatus','waitreply')">
                  <span>待回复</span>
                  <span>{{ statisticsCount.seller_wait_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.sellerReplyStatus === 'replyed'}" @click="handleFilter('sellerReplyStatus','replyed')">
                  <span>已回复</span>
                  <span>{{ statisticsCount.seller_replied_count }}</span>
                </div>
                <div class="filter-item" :class="{'active': form_data.sellerReplyStatus === 'appealing'}" @click="handleFilter('sellerReplyStatus','appealing')">
                  <span>申述中</span>
                  <span class="warn">{{ statisticsCount.appealing_count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <span class="select-desc">已选{{ checked_list.length }}条</span>
            <div class="batch-reply-btn" :class="{ disabled: !checked_list.length }" @click="checked_list.length && handleBatchReply()">批量回复</div>
          </div>
        </div>
      </div>
      <div class="table-box">
        <table>
          <colgroup>
            <col style="width: 60px;">
            <col style="width: 340px;">
            <col style="width: 500px;">
            <col style="width: 140px;">
            <col style="width: 100px;">
            <col style="width: 90px;">
          </colgroup>
          <thead>
            <tr>
              <th style="width: 60px;">
                <div class="col-check">
                  <Checkbox :indeterminate="indeterminate" :value="checkAll" @on-change="handleCheckAll"></Checkbox>
                </div>
              </th>
              <th style="width: 340px;">商品信息</th>
              <th style="width: 500px;">评价内容</th>
              <th style="width: 140px;">用户信息</th>
              <th style="width: 100px;">状态</th>
              <th style="width: 90px;">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in comment_list" :key="item.uuid">
              <td style="width: 60px;">
                <div class="col-check">
                  <Checkbox :value="checked_list.includes(item.uuid)" :label="item.uuid"
                    @on-change="(val) => handleSingleCheck(val, item.uuid)"></Checkbox>
                </div>
              </td>
              <td style="width: 340px;">
                <div class="col-product-info">
                  <div class="product-image">
                    <img v-viewer :src="item.product.image | default_img" alt="商品图片" />
                    <div v-if="item.sale_mode === 1" class="presale-tag">预售</div>
                  </div>
                  <div class="order-info">
                    <div class="order">
                      订单号：{{ item.ord.order_no || '-' }}
                    </div>
                    <div class="product-name">{{ item.product.name || '-' }}</div>
                    <div class="desc">{{ item.spec_info || '-' }} ×1</div>
                  </div>
                </div>
              </td>
              <td style="width: 500px;">
                <div class="col-comment-content">
                  <div class="comment-status-info">
                    <div class="status bg-green">好评</div>
                    <div class="score">
                      <img v-for="item in item.rating || 0" src="@/assets/images/icon-mall-collected.png" />
                      <img v-for="item in 5 - (item.rating || 0)" src="@/assets/images/icon-mall-collect.png" />
                    </div>
                    <div class="time">{{ item.create_time || '-' }}</div>
                  </div>
                  <div class="comment-content">
                    {{ item.content || '-' }}
                  </div>
                  <div class="comment-image">
                    <div class="image-item" v-for="(img, index) in item.image_list" :key="index">
                      <img v-if="img.type === 'image'" v-viewer :src="img.raw | default_img" alt="评价图片" />
                      <img v-if="img.type === 'video'" :src="`${img.raw}?x-oss-process=video/snapshot,t_1000,m_fast`" alt="评价视频" @click.stop="previewVideo(img.raw)" />
                      <img v-if="img.type === 'video'" src="@/assets/images/icon-play-evaluate.png" class="video-icon" alt="视频图标" />
                    </div>
                  </div>
                  <div v-if="item.seller_content" class="seller-reply-content">
                    {{ item.seller_content || '-' }}
                  </div>
                </div>
              </td>
              <td style="width: 140px;">
                <div class="col-user-info">
                  <div class="name">{{ item.frommember.nickname || item.frommember.username || '-' }}</div>
                  <div class="phone">{{ item.frommember.blur_mobile || '-' }}</div>
                </div>
              </td>
              <td style="width: 100px;">
                <div class="col-status">
                  <div v-if="[1, 4].includes(item.appeal_status)" class="status-text danger">申述审核中</div>
                  <div v-if="item.appeal_status === 3" class="status-text danger">申述不通过</div>
                  <div v-if="item.seller_reply_status === 'waitreply'" class="status-text warn">待回复</div>
                  <div v-else class="status-text gray">已回复</div>
                </div>
              </td>
              <td style="width: 90px;">
                <div class="col-action">
                  <div v-if="item.seller_reply_status === 'waitreply'" class="reply-btn" @click="showCommentDetail(item.uuid)">回复</div>
                  <div class="reply-btn" @click="showCommentDetail(item.uuid)">订单详情</div>
                  <div v-if="!item.appeal_status" class="reply-btn gray" @click="handleAppealReview(item)">申述评论</div>
                  <div v-if="[1, 4].includes(item.appeal_status)" class="reply-btn gray" @click="handleAppealReviewStatus(item)">申述进度</div>
                  <div v-if="item.appeal_status === 3" class="reply-btn gray" @click="handleAppealReviewStatus(item)">申述详情</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-container">
      <Page :total="total_count" size="small" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
    </div>

    <!-- 评价抽屉组件 -->
    <CommentDetailDrawer :visible.sync="drawerVisible" :comment_uuid="comment_uuid" @confirm="onDrawerClose" @showAppealReviewModal="showAppealReviewModal" />
    <!-- 回复抽屉组件 -->
    <MultipleReplyCommentDrawer :visible.sync="replyDrawerVisible" :selectedItems="checked_list" @confirm="onReplyDrawerClose" />
    <!-- 申述评价·提交平台审核弹窗组件 -->
    <AppealReviewModal :visible.sync="appealReviewModalVisible" :comment_uuid="comment_uuid" :appeal_id="appeal_id" @confirm="onAppealReviewModalClose" />
    <!-- 申述详情弹窗组件 -->
    <AppealReviewStatusModal :visible.sync="appealReviewStatusModalVisible" :appeal_id="appeal_id" @confirm="onAppealReviewStatusModalClose" @showAppealReviewModal="showAppealReviewModal" />
  </div>
</template>
<script>
import {
  GetShopCommentCount,
  GetShopComment,
} from "@/api/index";
import Popup from "@/components/Popup.vue";
import CommentDetailDrawer from "./components/commentDetailDrawer.vue";
import MultipleReplyCommentDrawer from "./components/multipleReplyCommentDrawer.vue";
import AppealReviewModal from "./components/appealReviewModal.vue";
import AppealReviewStatusModal from "./components/appealReviewStatusModal.vue";
import { mapState } from "vuex";
import util from '@/utils/util';
export default {
  name: "ShopCommentManage",
  components: {
    Popup,
    CommentDetailDrawer,
    MultipleReplyCommentDrawer,
    AppealReviewModal,
    AppealReviewStatusModal,
  },
  provide() {
    return {
      showOrderDetail: this.showOrderDetail,
    }
  },
  data() {
    return {
      util,
      uid: "",
      comment_uuid: '',
      appeal_id: 0,
      total_count: 0,
      comment_list: [],
      indeterminate: false,
      checkAll: false,
      checked_list: [],
      form_data: {
        page: 1,
        limit: 10,
        rating_tag: 'all',
        keyword: "",
        comment_type: '',
        sellerReplyStatus: '',
      },
      statisticsCount: {
        // 评价总数（本月 vs 上月）
        total_count: 0,
        total_count_pct: 0,
        // 好评率（本月 vs 上月）
        good_rate: 0,
        good_rate_pct: 0,
        // 待回复评价（本周 vs 上周，数量增减）
        seller_wait_count_week: 0,
        seller_wait_count_week_diff: 0,
         // 中差评（本周 vs 上周，数量增减）
        bad_mid_count_week: 0,
        bad_mid_count_week_diff: 0,
        // 好评/中评/差评
        good_count: 0,
        mid_count: 0,
        bad_count: 0,
        // 媒体类型
        has_image_count: 0,
        has_video_count: 0,
        reply_count: 0,
        // 商家回复状态
        seller_replied_count: 0,
        seller_wait_count: 0,
        appealing_count: 0,
      }, // 统计指标
      drawerVisible: false,
      replyDrawerVisible: false,
      appealReviewModalVisible: false,
      appealReviewStatusModalVisible: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    util.closeVideoPreview();
  },
  methods: {
    init() {
      this.checked_list = [];
      this.indeterminate = false;
      this.checkAll = false;
      this.comment_list = [];
      this.total_count = 0;
      this.form_data.page = 1;
      this.refresh();
    },
    refresh() {
      this.getProductList();
      this.onGetCount();
    },
    onPageChange(e) {
      console.log("page_change", e);
      this.form_data.page = e;
      this.getProductList();
    },
    handleSingleCheck(checked, uuid) {
      if (checked) {
        if (!this.checked_list.includes(uuid)) {
          this.checked_list.push(uuid);
        }
      } else {
        const index = this.checked_list.indexOf(uuid);
        if (index > -1) {
          this.checked_list.splice(index, 1);
        }
      }
      //>触发全选/半选响应
      this.onCheckChange();
    },
    onCheckChange(data) {
      console.log("data", data);
      if (this.checked_list.length === 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else if (this.checked_list.length === this.comment_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else {
        this.indeterminate = true;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      console.log("checkaaa");
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.checked_list = this.comment_list.map((item) => item.uuid);
        console.log("this.checked_list", this.checked_list);
      } else {
        this.checked_list = [];
      }
    },
    onSearch() {
      console.log("产品管理搜索");
      this.init();
    },
    async onGetCount() {
      try {
        const { data } = await GetShopCommentCount();
        this.statisticsCount = data || {};
        console.log("data", data);
      } catch (e) {
        console.log('e-count', e);
      }
    },
    async getProductList() {
      return GetShopComment({
        ...this.form_data,
        rating_tag: this.form_data.rating_tag === 'all' ? '' : this.form_data.rating_tag,
        // status: this.status,
      }).then((response) => {
        const { data } = response;
        this.comment_list = data && data.list || [];
        this.total_count = data && data.total || 0;
      });
    },
    handleFilter(type, value) {
      this.form_data[type] = value;
      this.init();
    },
    showCommentDetail(uuid) {
      this.drawerVisible = true;
      this.comment_uuid = uuid;
    },
    onDrawerClose() {
      console.log('抽屉关闭');
      this.init();
    },
    handleBatchReply() {
      this.replyDrawerVisible = true;
    },
    onReplyDrawerClose() {
      console.log('抽屉关闭');
      this.init();
    },
    handleAppealReview(item) {
      this.appealReviewModalVisible = true;
      this.comment_uuid = item.uuid;
      this.appeal_id = item.appeal?.id || 0;
    },
    onAppealReviewModalClose() {
      console.log('弹窗关闭');
      this.appeal_id = 0;
      this.comment_uuid = '';
      this.init();
    },
    handleAppealReviewStatus(item) {
      this.appealReviewStatusModalVisible = true;
      this.appeal_id = item.appeal?.id || 0;

    },
    onAppealReviewStatusModalClose() {
      console.log('弹窗关闭');
      this.appeal_id = 0;
      this.init();
    },
    previewVideo(url) {
      util.previewVideo(url);
    },
    showOrderDetail(order) {
      this.$emit('order-detail', order);
    },
    showAppealReviewModal(data) {
      this.appealReviewModalVisible = true;
      this.appeal_id = data.appeal_id;
      this.comment_uuid = data.uuid;
    },
  },
};
</script>
<style lang="scss" scoped>
.products {
  width: 100%;
  height: 100%;

  .content-wrapper {
    margin-top: 10px;
    padding: 24px 30px 20px 30px;
    background: #ffffff;

    &:first-child {
      margin-top: 0;
      padding: 30px 30px 20px 30px;
    }

    .title-box {
      width: 100%;
      border-bottom: 1px solid #d6d6d6;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        padding-bottom: 17px;
        border-bottom: 3px solid #ff5967;
      }

      .search-box {
        background: #F3F4F6;
        border-radius: 24px;
        display: flex;
        align-items: center;
        padding: 10px 20px;
        width: 280px;

        input {
          border: none;
          outline: none;
          background: transparent;
          flex: 1;
          padding-right: 10px;
        }

        .search-icon-btn {
          width: 22px;
          height: 22px;
          margin-left: 4px;
          cursor: pointer;
        }
      }
    }

    .info-card-box {
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 20px;

      .info-card {
        width: 24%;
        height: 96px;
        background: #F7FAFF;
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .top {
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          text-align: left;
        }

        .bottom {
          display: flex;
          align-items: baseline;

          .value {
            font-weight: bold;
            font-size: 24px;
            color: #1A1A1A;
          }

          .change-num {
            margin-left: 10px;
            font-weight: 400;
            font-size: 12px;
            color: #02C160;
          }

          .change-desc {
            margin-left: 4px;
            font-weight: 400;
            font-size: 12px;
            color: #02C160;
          }
        }
      }
    }

    .tool-bar-box {
      .title {
        font-weight: 400;
        font-size: 18px;
        color: #1A1A1A;
      }

      .divider-row {
        width: 100%;
        height: 1px;
        background: #e3e3e3;
        margin: 16px 0 20px 0;
      }

      .filter-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 24px 46px;

          .filter-item-box {
            display: flex;
            align-items: center;
            gap: 10px;

            .filter-item-value-box {
              display: flex;
              align-items: center;
              gap: 10px;
              height: 41px;
              padding: 4px;
              background: #F5F6F8;
              border-radius: 8px;
            }

            .filter-item {
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 6px 12px;
              cursor: pointer;

              &.active {
                color: #FF5967;
                background: #ffffff;
              }
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .select-desc {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-right: 10px;
          }

          .batch-reply-btn {
            width: 104px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #FF5967;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #FF5967;

            &:hover {
              opacity: 0.9;
            }
            &.disabled {
              border-color: #e3e3e3;
              color: #999999;
              cursor: not-allowed;
            }
          }
        }
      }
    }

    .table-box {
      margin-top: 20px;
      width: 100%;
      overflow: auto;

      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          background: #F6F7FA;
          height: 56px;

          tr {
            th {
              // text-align: center;
              vertical-align: middle;
              padding: 10px;
              overflow: hidden;
              // text-overflow: ellipsis;
              // white-space: nowrap;
              &.col-check{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                padding: 12px;
                // ::v-deep .ivu-checkbox-group-item,
                // .ivu-checkbox-wrapper-checked {
                //   border-spacing:0;
                // }
              }
            }
          }
        }

        tbody {
          tr {
            // box-shadow: inset 0 0 0 1px #e6e6e6;
            border: 1px solid #e3e3e3;
            // border-radius: 8px;

            td {
              vertical-align: middle;
              // text-align: center;
              padding: 10px;
              overflow: hidden;

              .col-check {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                padding: 12px;

                ::v-deep .ivu-checkbox-group-item,
                .ivu-checkbox-wrapper-checked {
                  border-spacing:0;
                  span {
                    &:nth-child(2) {
                      display: none;
                    }
                  }
                }
              }

              .col-product-info {
                text-align: left;
                display: flex;
                gap: 10px;
                width: 100%;

                .product-image {
                  width: 72px;
                  height: 72px;
                  flex-shrink: 0;
                  border: 1px solid #e3e3e3;
                  border-radius: 8px;
                  overflow: hidden;
                  position: relative;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    cursor: pointer;
                  }

                  .presale-tag {
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: #ff5967;
                    border-radius: 8px 0 8px 0;
                    padding: 3px 5px;
                    font-size: 12px;
                    color: #FFFFFF;
                  }
                }

                .order-info {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  gap: 4px;
                  flex: 1;
                  min-width: 0;

                  .product-name {
                    font-size: 14px;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .desc,
                  .order {
                    font-size: 14px;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }

              .col-comment-content {
                display: flex;
                flex-direction: column;
                gap: 8px;
                width: 100%;

                .comment-status-info {
                  display: flex;
                  align-items: center;

                  .status {
                    padding: 2px 6px;
                    border-radius: 4px;
                    font-size: 12px;
                    color: #FFFFFF;
                  }

                  .score {
                    margin-left: 6px;
                    display: flex;
                    align-items: center;

                    img {
                      width: 16px;
                      height: 16px;
                    }
                  }

                  .time {
                    margin-left: 12px;
                    font-size: 12px;
                    color: #999999;
                  }
                }

                .comment-content {
                  font-size: 14px;
                  color: #333333;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-all;
                }

                .comment-image {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 8px;

                  .image-item {
                    position: relative;
                    width: 54px;
                    height: 54px;
                    background: #D9D9D9;
                    border-radius: 4px 4px 4px 4px;
                    cursor: pointer;

                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }

                    .video-icon {
                      position: absolute;
                      top: 4px;
                      right: 4px;
                      width: 16px;
                      height: 16px;
                      object-fit: cover;
                    }
                  }
                }

                .seller-reply-content {
                  padding: 4px 11px;
                  background: #F8F9FB;
                  border-radius: 4px;
                  font-size: 12px;
                  color: #666666;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .col-user-info {
                display: flex;
                flex-direction: column;
                gap: 4px;

                .name {
                  font-size: 14px;
                  color: #333333;
                }

                .phone {
                  font-size: 14px;
                  color: #666666;
                }
              }

              .col-status {
                display: flex;
                flex-direction: column;
                gap: 6px;

                .status-text {
                  font-size: 14px;
                }
              }

              .col-action {
                display: flex;
                flex-direction: column;
                gap: 8px;

                .reply-btn {
                  font-size: 14px;
                  color: #333333;
                  cursor: pointer;

                  &:hover {
                    color: #FF5967;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.commission-box {
  .cancel-btn {
    width: 130px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #E3E3E3;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }

  .confirm-btn {
    width: 130px;
    height: 44px;
    background: #FF5967;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
  }

  ::v-deep .ivu-input {
    text-align: center;
  }
}

.page-container {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
}

.warn {
  color: #FF5000 !important;
}

.danger {
  color: #FF5967 !important;
}

.gray {
  color: #999999 !important;
}

.bg-green {
  background: #02C160 !important;
}

.bg-orange {
  background: #FF5000 !important;
}

.bg-blue {
  background: #0D99FF !important;
}
</style>
